<template>
	<Modal @close="closeModal" :draggable="false">
		<template slot="title">Sales Order / Invoice History</template>
		<template slot="body">
			<!-- <div class="popup_body"> -->
			<div :style="company_id === 'beautyplus' || company_id === 'hairplus' ? 'width:1550px; height:900px;' : 'width:1050px; height:700px;'" v-on:keyup.esc="closeModal">
				<table class="list_tbl">
					<thead>
						<tr>
							<th width="5%">Update Date Time</th>
							<th width="3%">Update User</th>
							<th width="5%">Status</th>
							<th width="3%">Sales Group</th>
							<th width="4%">Entry Date</th>
							<th width="4%">Request Date</th>
							<th width="4%">Ready Date</th>
							<th width="4%">Pick Up Date</th>
							<th width="8%">Description</th>
							<th width="2%">Request Quantity</th>
							<th width="2%">Pick Quantity</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="history in sampleHistoryList" v-bind:key="history.sample_history_no">
							<td class="al_center">{{ history.upd_dt | moment('MM-DD-YYYY HH:mm:ss') }}</td>
							<td class="al_center">{{ history.upd_user }}</td>
							<td class="al_center">{{ history.status_code | sampleStatusName }}</td>
							<td class="al_center">{{ history.sales_group_code }}</td>
							<td class="al_center">{{ history.entry_date }}</td>
							<td class="al_center">{{ history.request_date }}</td>
							<td class="al_center">{{ history.ready_date }}</td>
							<td class="al_center">{{ history.pickup_date }}</td>
							<td class="al_center">{{ history.description }}</td>
							<td class="al_right">{{ history.total_request_quantity | commaSeparated }}</td>
							<td class="al_right">{{ history.total_pick_quantity | commaSeparated }}</td>
						</tr>
					</tbody>
				</table>

				<div class="popup_bottom">
					<a href="javascript:void(0);" @click="closeModal" class="gray_bt">Close</a>
				</div>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@/components/common/Modal';
export default {
	name: 'SampleHistory',
	props: {
		sampleHistoryList: [],
	},
	components: {
		Modal,
	},
	methods: {
		closeModal() {
			this.$emit('click');
		},
	},
	computed: {
		company_id() {
			return this.$session.get('user').company_id;
		},
	},
};
</script>

<style scoped></style>
